module.exports = __webpack_public_path__ + "img/143ne.d1c630a9.svg";